module.exports = __webpack_public_path__ + "static/media/hipwig-details.48490ed8.jpg";